import { render, staticRenderFns } from "./CheckboxBar.vue?vue&type=template&id=4ed84cb8&scoped=true"
import script from "./CheckboxBar.vue?vue&type=script&lang=js"
export * from "./CheckboxBar.vue?vue&type=script&lang=js"
import style0 from "./CheckboxBar.vue?vue&type=style&index=0&id=4ed84cb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed84cb8",
  null
  
)

export default component.exports